import { PropsWithChildren } from 'react';
import { SettingsPanelAccordion } from './settings-panel-accordion';
import { SettingsPanelBody } from './settings-panel-body';
import { SettingsPanelButton } from './settings-panel-button';
import { SettingsPanelHeader } from './settings-panel-header';
import { SettingsPanelOverlay } from './settings-panel-overlay';

export const SettingsPanel = ({ children }: PropsWithChildren) => {
  return (
    <div
      className='composer-settings-panel'
      css={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden auto',
      }}
    >
      {children}
    </div>
  );
};

SettingsPanel.Accordion = SettingsPanelAccordion;
SettingsPanel.Body = SettingsPanelBody;
SettingsPanel.Button = SettingsPanelButton;
SettingsPanel.Header = SettingsPanelHeader;
SettingsPanel.Overlay = SettingsPanelOverlay;
